import React, { Component } from "react";
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import EventAdmin from './modules/EventAdmin'
import './index.css';
import Utils from './modules/Utils';

class App extends Component {
  constructor(props){
    super(props);
    this.state = {
      isLoginOpen: true, // dialog pro heslo
      maxPeople: 100, // Max. počet lidí na akci  
      password: "",
      validPassword:"ak",
      messagePassword:"",
      
      eventData:[], // Data Eventů pro rezervace

    }
    // this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangePwd = this.handleChangePwd.bind(this);

  }

  // Iniciální načtení dat
  componentDidMount() {
    this.getEvents();
    //Poprvé hned aby se nečekalo v count
   
  }

  handleChangePwd(event) {
    this.setState({password: event.target.value });       
  }
  
  handleDialogAnswerClose = () => {
    if ( this.state.password === this.state.validPassword) {
      this.setState({messagePassword:""}); // Zádné info k heslu    
      this.setState({isLoginOpen: false}); // zavře dialog Answer
    }
    else{
      this.setState({messagePassword:"Chybné heslo!"}); // Zádné info k heslu
    }
  };


  // Načtení pole osazenosti mše
  getEvents(){

    var formData = new FormData();
        formData.append('getEvents', true);
     
      let fetchData = { 
        method: 'POST', body: formData,      
        headers: {
           headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        },  
      }

    // A posílám
    fetch(Utils.getURL(), fetchData)   
    .then(response => response.json())
    .then(data => {          
        if ( data["success"]) {
        // Načtení data.data do tabulky
            if ( data["count"] > 0) {
              this.setState({eventData: data.data }); // Po přihlášení na hlavní stránku                    
            }
            else {
              this.setState({eventData: [] }); // Po přihlášení na hlavní stránku                    
            }        
        
        // console.log('Stav:', "OK");  
      }
        else{
          console.error('Chyba:', "Nejsou data");
              }            
    })
    .catch((error) => {
      console.error('Chyba:', error);
    });    
}

  render() { 
    return (
      <div >
                {/* Odpověď */}
        <Dialog fullScreen disableBackdropClick
          open={this.state.isLoginOpen}  
          onClose={this.handleDialogAnswerClose}
        >
        <DialogTitle  id="answer-dialog-title">Zadejte heslo</DialogTitle>
        <DialogContent>
        <DialogContentText id="answer-dialog-description">
          
          <TextField variant="outlined" margin="normal" required fullWidth name="password" label="Heslo"
            type="password" id="password" autoComplete="current-password" 
            // value={this.state.password.value}
            onChange = {this.handleChangePwd}
            />

            {this.state.messagePassword}
            </DialogContentText>
            <Button color="primary" variant="contained" 
              onClick={this.handleDialogAnswerClose} >
            OK
          </Button>  
            </DialogContent>
        <DialogActions>
        <p className="center">
        </p>
          </DialogActions>         
        </Dialog>
        

      {/* Pokračování */}

        <AppBar position="sticky">
      {/* <AppBar position="static"> */}
                <Toolbar>
                  <IconButton edge="start" color="inherit" 
                    onClick={() => { 
                      window.location.href='http://augustinbrno.cz'; } }                                   
                      aria-label="menu">
                    <ArrowBackIcon />
                  </IconButton>
                  <Typography className="modulename" variant="h6" >
                  Bohoslužby - administrace
                  </Typography> 
                            
                </Toolbar>
      </AppBar>
    
    <Grid container spacing={2}>
    
      <div >
        {this.state.eventData.map((item, index) =>
          <Grid item xs={12} >                
            <EventAdmin  myId ={item.event_id} myMax={item.event_max} 
            myName={item.event_name} 
            myComment={item.event_comment}
            >
            </EventAdmin>
        </Grid>
          )
        }
      </div>
  </Grid>
      <br></br><br></br><br></br><br></br><br></br>
      <footer>
      <Typography variant="body2" color="textSecondary" align="center">
        { 'v1.04 Copyright © KAK 2020'}      
        </Typography>
        </footer>
      </div>
    );
  }
}

export default App;